import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { FcCalendar, FcViewDetails } from "react-icons/fc";
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from "react-router-dom";
import Toast from '../../../helpers/Toast';
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from '../../../models/Assistance/AssistanceListDTO';
import { CreateAssistanceDTO } from '../../../models/Assistance/CreateAssistanceDTO';
import { GetAssistancesFromClientDTO } from '../../../models/Client/GetAssistancesFromClientDTO';
import { AssistanceService } from '../../../services/AssistanceService';
import { ClientService } from '../../../services/ClientService';
import TableComponent from "../../TableComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../ButtonComponent";
import { useNavigateToAssistanceCreate } from "../../../AssistanceUtilities";
import { AssistancesFromClientProps } from "../AssistancesFromClient";
import Routes from "../../../helpers/Routes";
import { useNavigateToClientAssistancesHistoryDashboard } from "../../../ClientUtilities";

function AssistancesFromClientA({ ...props }: AssistancesFromClientProps) {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const assistanceService = new AssistanceService();
    const navigate = useNavigate();
    const intl = useIntl();


    const [assistances, setAssistances] = useState<AssistanceListDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    //#region Módulos ativos
    const { availableModules } = useAvailableModulesContext();
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActiveKpiModule, setIsActiveKpiModule] = useState<boolean>(false);
    useEffect(() => {
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActiveKpiModule")) {
            setIsActiveKpiModule(true);
        }
    }, [availableModules]);
    //endregion

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Document" />,
                accessor: "id",
                width: 15,
                Cell: (props: any) => {
                    return Utilities.FormattedAssistanceDocument(props.cell.row.original.docType, props.cell.row.original.serie, props.cell.row.original.number);
                },
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Date" />,
                accessor: "date",
                width: 20,
                Cell: (props: any) => {
                    return props.cell.row.original.dateString;
                },
            },
            ...(isActiveCarPlate ? [{
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.EquipmentCarPlate" />,
                accessor: "equipment.carPlate",
                width: 10,
            }] : []),
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.EquipmentSerialNumber" />,
                accessor: "equipment.serialNumber",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.EquipmentBrand" />,
                accessor: "equipment.brand",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.EquipmentModel" />,
                accessor: "equipment.model",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.AssistanceStatus" />,
                accessor: "status",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Technician" />,
                accessor: "technician",
                width: 10,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Ver Detalhes" aria-label="Ver Detalhes" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        createAssistance(
                                            "",
                                            props.cell.row.original.equipment.erpId,
                                            props.cell.row.original.equipment.serialNumber,
                                            props.cell.row.original.equipment.brand,
                                            props.cell.row.original.equipment.model,
                                            id!,
                                            props.cell.row.original.number,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie
                                        );
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
                width: 5
            },
        ],
        [isActiveCarPlate]
    );

    const GetAssistances = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetAssistancesFromClientDTO = {
            clientErpId: id! ?? props.clientErpId,
            currentPage: currentPage,
            pageSize: pageSize,
        }
        var response = await clientService.GetAssistancesFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setAssistances(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    const createAssistance = async (projectErpId: string, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: null,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: null,
            budgetCostPrice: null
        };

        var response = await assistanceService.Create(sendData);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Backoffice/Assistance/${response.obj}`);
    };


    useEffect(() => {
        if (id && isLoading) {
            GetAssistances(currentPage ?? 1, pageSize ?? 5)
        }
    }, [])

    //#region Navegar para criação de uma nova assistência, passando dados do cliente
    const navigateToCreate = useNavigateToAssistanceCreate(); // tenho de fazer isto e não ser direto pq "React Hook "useNavigateToMaintenancePlanCreate" cannot be called inside a callback. React Hooks must be called in a React function component or a custom React Hook function"
    //endregion

    //#region Navegar ClientAssistancesHistoryDashboard
    const navigateToClientAssistancesHistoryDashboard = useNavigateToClientAssistancesHistoryDashboard();
    //endregion

    return (
        <div>
            <div>
                <Row style={{ margin: "1rem 0px" }}>
                    {(props.showCreateNewAssistanceButton &&
                        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Screens.AssistancesFromClient.Button.Create.Assistance" })}
                                onClick={() => navigateToCreate(props?.clientErpId, props?.clientName)}
                                style={{ minHeight: "37px", marginTop: "10px", marginBottom: "10px", display: "flex", justifyContent: "center" }}
                            />
                        </Col>
                    )}
                    {(isActiveKpiModule && props.showKpiClientAssistancesHistoryDashboardButton &&
                        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                            <ButtonComponent
                                text={"Historial de Assistências"} // ver este nome posteriormente
                                onClick={() => navigateToClientAssistancesHistoryDashboard(props?.clientErpId, props?.clientName)}
                                style={{ minHeight: "37px", marginTop: "10px", marginBottom: "10px", display: "flex", justifyContent: "center" }}
                            />
                        </Col>
                    )}
                </Row>
            </div>

            <Row style={{ margin: "1rem 0px" }}>
                <TableComponent
                    columns={columns}
                    data={assistances}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetAssistances}
                    initialSortBy={[]}
                    disableSortBy={true}
                    dontOrderFirstCollumn={true}
                />
            </Row>
        </div>
    );
}

export default AssistancesFromClientA